export default __webpack_public_path__ + "pgnv-assets/a83cc82b1edc901263ff82d67f1b4e3c.png";